import {
  getEvaluationCore,
  type EvaluationRowState,
  type EvaluationState,
  type EvaluationVerdict,
  type EvaluationView,
} from 'types';

// Intentionally differs from server precedence: client checks incomplete first, server checks fail first.
// This is kept intentional to preserve completion gating. Do not "fix" this to match the server.
export const rollUpVerdict = (rowVerdicts: EvaluationVerdict[]): EvaluationVerdict => {
  if (rowVerdicts.length === 0) return 'incomplete';
  if (rowVerdicts.some((v) => v === 'incomplete')) return 'incomplete';
  if (rowVerdicts.some((v) => v === 'fail')) return 'fail';
  return 'pass';
};

// Computes the live evaluation state from the view's derived values and the tech's
// locally entered values, using the same pure core descriptor the server uses. Rows
// with no registered core are treated as `incomplete`.
export const computeLiveEvaluationState = (
  view: EvaluationView,
  enteredByRow: Record<string, number | null>[],
): EvaluationState => {
  const core = getEvaluationCore(view.key);

  const rows: EvaluationRowState[] = view.rows.map((row, index) => {
    const entered = enteredByRow[index] ?? row.entered;
    const verdict = core ? core.computeRow(row.derived, entered, view.params).verdict : 'incomplete';
    return { entered, verdict };
  });

  return {
    key: view.key,
    rows,
    verdict: rollUpVerdict(rows.map((r) => r.verdict)),
  };
};
